module.exports = __webpack_public_path__ + "327cef5567428f96d12fcd012923f299.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logomobile.png
// module id = 797
// module chunks = 0